import * as Api from '../weborder/Api';

// legacy - remove when Address Internationalisation is 100% released
const getOneLineDisplayAddress = (
  data: Api.DeliveryLocation,
  addressLayout: number,
): string => {
  let singleLineAddress = '';

  const postCode = data.PostCode ? ` ${data?.PostCode}` : '';

  if (addressLayout === Api.AddressLayoutType.FullStreetAddressFirst) {
    singleLineAddress = `${data.Street}, ${
      data?.Building ? `${data?.Building}, ` : ''
    } ${data?.Town}${postCode}`;
    return singleLineAddress;
  }

  const building = data?.Building ? `${data?.Building}` : '';
  singleLineAddress = `${building} ${data.Street}`;
  return singleLineAddress;
};

// legacy - remove when Address Internationalisation is 100% released
const getTwoLineDisplayAddress = (
  data: Api.DeliveryLocation,
  addressLayout: number,
): string[] => {
  const building = data.Building ? `${data?.Building}` : '';
  const postCode = data.PostCode ? ` ${data?.PostCode}` : '';

  let addressLineOne = '';
  let addressLineTwo = '';
  let fullTwoLineAddress = [];

  if (addressLayout === Api.AddressLayoutType.FullStreetAddressFirst) {
    addressLineOne = `${data.Street}, ${building}`;
    addressLineTwo = `${data?.Town}${postCode}`;
    fullTwoLineAddress = [addressLineOne, addressLineTwo];
    return fullTwoLineAddress;
  }

  addressLineOne = `${building} ${data.Street}`;
  addressLineTwo = `${data?.Town}${postCode}`;
  fullTwoLineAddress = [addressLineOne, addressLineTwo];
  return fullTwoLineAddress;
};

export const addressUtils = {
  getOneLineDisplayAddress,
  getTwoLineDisplayAddress,
};
